var GaugeChartModule = /** @class */ (function () {
    function GaugeChartModule() {
    }
    return GaugeChartModule;
}());
export { GaugeChartModule };
